Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MDXEmbedProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@mdx-js/react");
var _components = require("./components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MDXEmbedProvider = function MDXEmbedProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react2.MDXProvider, {
    components: _components.components
  }, children);
};
exports.MDXEmbedProvider = MDXEmbedProvider;